// src/Utils/axiosAuth.js
// Подключается ОДИН раз при старте приложения (см. index.js).
// Цепляет JWT-токен из localStorage в заголовок Authorization для всех
// запросов к твоему API. Это чинит «постоянно просит перезайти» после
// переезда на новый домен, т.к. вход больше не зависит только от куки.

import axios from "axios";
import { getServerUrl } from "./serverSelector";

// Ключи, под которыми saveJwtToken мог сохранить токен.
// Если у тебя в authStorage свой ключ — добавь его ПЕРВЫМ в список.
const TOKEN_KEYS = ["jwt", "jwtToken", "token", "authToken", "accessToken"];

function getToken() {
    try {
        for (const k of TOKEN_KEYS) {
            const v = localStorage.getItem(k);
            if (v) return v;
        }
    } catch (_) { /* ignore */ }
    return null;
}

const API_BASE = (getServerUrl() || "").replace(/\/$/, "");

// Запрос идёт на НАШ бэкенд? (относительный URL или начинается с API_BASE).
// Чтобы случайно не отправить токен на сторонние сервисы (AllPay и т.п.).
function isOurApi(url = "") {
    if (!/^https?:\/\//i.test(url)) return true;       // относительный путь
    return API_BASE && url.startsWith(API_BASE);
}

let installed = false;

export function setupAxiosAuth() {
    if (installed) return;
    installed = true;

    // Куки тоже шлём (если бэкенд их использует) — не мешает токену
    axios.defaults.withCredentials = true;

    axios.interceptors.request.use((config) => {
        if (isOurApi(config.url)) {
            config.withCredentials = true;
            const tok = getToken();
            if (tok) {
                config.headers = config.headers || {};
                if (!config.headers.Authorization) {
                    config.headers.Authorization = `Bearer ${tok}`;
                }
            }
        }
        return config;
    });
}

export default setupAxiosAuth;